<template>
  <div class="row">
    <div class="col-md-12">
      <div class="card">
        <div class="card-body">
          <h5 class="card-title">Información de Empresa No. {{ data.id }}</h5>
          <h6 class="card-subtitle mb-2 text-muted">{{data.name}}</h6>
          <h6 class="card-subtitle mb-2 text-muted">{{data.active ? 'Activa' : 'Inactiva'}}</h6>
          <div class="card mt-5">
            <div class="card-header row">
                <div class="col-lg-6">Información Básica</div>
                <div class="text-right col-lg-6">
                    <button class="btn btn-orange" @click="editarInfo">Editar</button>
                </div>
            </div>
            <div class="card-body">
              <div class="row">
                <div class="col-md-4">
                  <h6>Sucursal</h6>
                </div>
                <div class="col-md-3">
                  <h6>Email</h6>
                </div>
                <div class="col-md-2">
                  <h6>Teléfono</h6>
                </div>
                <div class="col-md-3">
                  <h6>Dirección</h6>
                </div>
              </div>
              <div class="row">
                <div class="col-md-4">{{ data.name }}</div>
                <div class="col-md-3">{{ data.email }}</div>
                <div class="col-md-2">{{ data.phone }}</div>
                <div class="col-md-3">{{ data.address }}</div>
              </div>
            </div>
          </div>

          <!-- <div class="card mt-3">
            <div class="card-header row">
                <div class="col-lg-6">Configuración</div>
                <div class="text-right col-lg-6">
                    <button @click="editarInfo">editar</button>
                </div>
            </div>
            <div class="card-body">
              <div class="row">
                <div class="col-md-4">
                  <h6>Sucursal</h6>
                </div>
                <div class="col-md-3">
                  <h6>Email</h6>
                </div>
                <div class="col-md-2">
                  <h6>Teléfono</h6>
                </div>
                <div class="col-md-3">
                  <h6>Dirección</h6>
                </div>
              </div>
              <div class="row">
                <div class="col-md-4">{{ data.name }}</div>
                <div class="col-md-3">{{ data.email }}</div>
                <div class="col-md-2">{{ data.phone }}</div>
                <div class="col-md-3">{{ data.address }}</div>
              </div>
            </div>
          </div> -->

          <div class="card mt-3">
            <div class="card-header">
              Estado de cuenta
            </div>
            <div class="card-body">
              <div class="row text-center">
                <div class="col-md-4">
                  <h6>Pedidos activos</h6>
                </div>
                <div class="col-md-4">
                  <h6>Piezas en inventario</h6>
                </div>
                <div class="col-md-4">
                  <h6>Total de Venta hoy</h6>
                </div>
              </div>
              <div class="row text-center">
                <div class="col-md-4">{{ data.numero_ordenes_solicitadas }} <br /><a href="#" @click="showDetails('comensales')">ver más</a ></div>
                <div class="col-md-4">{{ data.numero_ordenes_inventario }} <br /><a href="#" @click="showDetails('abonos')">ver más</a ></div>
                <div class="col-md-4">$ {{ data.total_venta_hoy }} <br /><a href="#" @click="showDetails('cargos')">ver más</a ></div>
              </div>
            </div>
          </div>

          <div class="card mt-3">
            <div class="card-header">
              Acciones rapidas
            </div>
            <div class="card-body">
               <button class="btn btn-purple mr-4" @click="AddOrder()">Realizar Pedido</button>
               <button class="btn btn-purple mr-4" @click="AddSales()">Generar Venta</button>
               <!-- <button class="btn btn-purple mr-4" @click="setPrint()">Imprimir Contrato</button> -->
            </div>
          </div>
          <div class="card mt-3">
            <div class="card-header">
              CONFIGURACION DE FOOTER PARA LOS TICKETS
            </div>
            <div class="row justify-content-center">
              <div class="col-lg-11">
                <h6>Números de teléfono</h6>
              </div>
              <div class="row">
                <div class="col-lg-4">
                  <button class="btn btn-purple" @click="addPhone">
                    <font-awesome-icon :icon="['fa', 'plus']" class="fontIconBtn" size="1x"/>
                  </button>
                </div>
                <div class="col-lg-4" v-if="phonesFooter.length > 0">
                  <button class="btn btn-purple" @click="savePhones">
                    <font-awesome-icon :icon="['fa', 'save']" class="fontIconBtn" size="1x"/>
                      Guardar
                  </button>
                </div>
                <!-- {{phonesFooter}} -->
                <div class="col-lg-10" v-for="(p, index) in phonesFooter" :key="index">
                  <label for="">Número de teléfono: </label>
                  <input type="phone" class="form-control" maxlength="10" v-model="p.phone">
                </div>
              </div>
            </div>
            <div class="row justify-content-center mt-5">
              <h6>INFORMACIÓN PARA EL TICKET DE COMPRA:</h6>
              <div class="col-lg-10 mt-1 text-center mb-5">
                <textarea v-model="textoFooter" id="" cols="80" rows="4" placeholder="INFORMACIÓN ADICIONAL A MOSTRAR AL FONDO DE CADA TICKET"></textarea>
              </div>
              <h6>INFORMACIÓN PARA EL VALE DE DEVOLUCIÓN:</h6>
              <div class="col-lg-10 mt-1 text-center">
                <textarea v-model="couponFooter" id="" cols="80" rows="4" placeholder="INFORMACIÓN ADICIONAL A MOSTRAR AL FONDO DE CADA TICKET"></textarea>
              </div>
              <div class="col-lg-10 mt-4 text-center">
                <button class="btn btn-purple" @click="saveTextFooter">
                  <font-awesome-icon :icon="['fa', 'save']" class="fontIconBtn" size="1x"/>
                    Guardar
                </button>
              </div>
            </div>
          </div>
          <div class="card mt-3">
            <div class="card-header">
              Comentarios - Observaciones
            </div>
          </div>
        </div>
      </div>
    </div>
    <modal name="editInfo" :scrollable="true" height="650" class="">
      <div class="text-right">
        <span class="close-modal" @click="$modal.hide('editInfo')">
          <font-awesome-icon :icon="['fa', 'times-circle']" />
        </span>
      </div>
      <div class="reset-pass">
        <h2 class="text-center">Editar Información</h2>
        <div class="form-group col-11">
           <label for="exampleInputEmail1">Sucursal</label>
           <input type="text" class="form-control ml-3" v-model="data.name" id="exampleInputEmail1" aria-describedby="emailHelp" placeholder="Nombre">
        </div>
        <div class="form-group col-11">
            <label for="exampleInputPassword1">Dirección</label>
            <input type="text" class="form-control ml-3" v-model="data.address" placeholder="Dirección">
        </div>
        <div class="form-group col-11">
            <label for="exampleInputPassword1">Estado</label>
            <input type="text" class="form-control ml-3" v-model="data.state" placeholder="Estado">
        </div>
        <div class="form-group col-11">
            <label for="exampleInputPassword1">Ciudad</label>
            <input type="text" class="form-control ml-3" v-model="data.city" placeholder="Ciudad">
        </div>
        <div class="form-group col-11">
            <label for="exampleInputPassword1">Teléfono</label>
            <input type="phone" class="form-control ml-3" v-model="data.phone" placeholder="Teléfono">
        </div>
        <div class="form-group col-11">
            <label for="exampleInputPassword1">Email</label>
            <input type="email" class="form-control ml-3" v-model="data.email" placeholder="Email">
        </div>
        <div class="text-center">
            <button type="submit" class="btn btn-primary text-center" @click="updateInfo">Actualizar</button>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import axiosAdelaService from '@/axios/axiosAdelaService'
import formatData from '@/mixins/formatAxios'
import { mapGetters } from 'vuex'

export default {
  mixins: [formatData],
  data () {
    return {
      phonesFooter: [],
      couponFooter: [],
      textoFooter: '',
      ordenesActivas: 0,
      showComensales: false,
      showAbonos: false,
      showCargos: false,
      comensales: [],
      cargos: [],
      abonos: [],
      data: [],
      contrato: '',
      titleModal: '',
      editInfo: {
        name: '',
        lastname1: '',
        lastname2: '',
        address: '',
        phone: '',
        email: ''
      }
    }
  },
  computed: {
    ...mapGetters({
      user: 'getUser'
    })
  },
  methods: {
    async updateInfo () {
      try {
        const request = {
          name: this.data.name,
          state: this.data.state,
          city: this.data.city,
          phone: this.data.phone,
          address: this.data.address,
          email: this.data.email,
          enterprise_id: this.data.id
        }
        const abonos = await axiosAdelaService.post('/updateInfoEnterprise', request)
        if (abonos.status === 200) {
          this.$toastedPush({
            message: 'Sucursal actualizada',
            type: 'success'
          })
          this.$modal.hide('editInfo')
        }
      } catch (error) {
        this.showError('No se pudieron obtener los datos intentalo mas tarde.')
      }
    },
    async getInfoEnterprise (data) {
      try {
        console.log('getInterprise', data)
        const request = {
          enterprise_id: data.enterprise_id
        }

        const enterprise = await axiosAdelaService.post('/getInfoEnterprise', request)
        console.log(enterprise)
        if (enterprise.status === 200) {
          this.data = enterprise.data.rows
          this.textoFooter = this.data.footerText
          this.couponFooter = this.data.couponFooter
        }
      } catch (error) {
        this.showError('No se pudieron obtener los datos intentalo mas tarde.')
      }
    },
    AddOrder () {
      this.$router.push({ name: 'addOrders' })
    },
    AddSales () {
      this.$router.push({ name: 'addsales' })
    },
    editarInfo () {
      this.$modal.show('editInfo')
    },
    addPhone () {
      this.phonesFooter.push({ phone: null })
    },
    async savePhones () {
      try {
        const request = {
          data: this.phonesFooter,
          enterprise_id: this.data.id
        }
        const enterprise = await axiosAdelaService.post('/addPhonesTienda', request)
        console.log(enterprise)
        if (enterprise.status === 200) {
          this.$toastedPush({
            message: 'Teléfonos actualizados',
            type: 'success'
          })
        }
      } catch (error) {
        this.showError('No se pudieron obtener los datos intentalo mas tarde.')
      }
    },
    async getPhonesFooter () {
      try {
        const request = {
          enterprise_id: this.data.id
        }
        const phones = await axiosAdelaService.post('/getPhonesTienda', request)
        if (phones.status === 200) {
          for (const key in phones.data.rows) {
            this.phonesFooter.push({ phone: phones.data.rows[key].phone })
          }
        }
      } catch (error) {
        this.showError('No se pudieron obtener los datos intentalo mas tarde.')
      }
    },
    async saveTextFooter () {
      try {
        const request = {
          text: this.textoFooter,
          vale: this.couponFooter,
          enterprise_id: this.data.id
        }
        const phones = await axiosAdelaService.post('/addFooterTextEnterprise', request)
        if (phones.status === 200) {
          this.$toastedPush({
            message: 'Texto de footer actualizado',
            type: 'success'
          })
        }
      } catch (error) {
        this.showError('No se pudieron obtener los datos intentalo mas tarde.')
      }
    }
  },
  watch: {
  },
  async mounted () {
    try {
      this.data = this.$route.params
      console.log('Parametros', this.$route.params)
      await this.getInfoEnterprise(this.data)
      await this.getPhonesFooter()
    } catch (error) {
      this.showError('No se pudieron obtener los datos intentalo mas tarde.')
    }
  }
}
</script>

<style>
</style>
